import { configureStore } from "@reduxjs/toolkit";
import ReqList from "./Reducers/NewReqList-reducer";
import Restaurant from "./Reducers/Restaurant-reducer";
import Customer from "./Reducers/Customer-reducer";
import Transaction from "./Reducers/Transaction-reducer";
import LicenseApiKeys from "./Reducers/LicenseApiKeys-reducer";
import Payment from "./Reducers/Payment-reducer";
// import PaymentsChange from "./Reducers/PaymentChange-reducer";
const store = configureStore({
  reducer: {
    restReqList: ReqList,
    Customer,
    Restaurant,
    Transaction,
    LicenseApiKeys,
    Payment,
    // PaymentsChange,
  },
});

export default store;
